<template>
  <v-data-table
    :items="education"
    :disable-initial-sort="true"
    :headers="headers"
    :rows-per-page-items="[100]"
    :no-data-text="trans('app.search.no_data')"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <tr>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.tutor }}</td>
        <td>{{ props.item.video }}</td>
        <td>{{ props.item.name }}</td>
        <td>
          {{
            props.item.short_description.length > 255
              ? `${props.item.short_description.substring(0, 255)}...`
              : props.item.short_description
          }}
        </td>
        <td>
          {{
            props.item.description.length > 255
              ? `${props.item.description.substring(0, 255)}...`
              : props.item.description
          }}
        </td>
        <td>
          {{ props.item.roles.map(r => trans(`page.roles.${r}`)).join(', ') }}
        </td>
        <td>{{ `app.education.${props.item.type}` | trans }}</td>
        <td>
          <icon-button
              icon="edit"
              color="success"
              cls="mr-0 ml-0"
              :tooltip="{top: true, bottom: false, attach: false}"
              :iconOptions="{small: true}"
              @click="editEducation(props.item)"
          >
            {{ 'app.show_and_edit' | trans }}
          </icon-button>
          <icon-button
            icon="delete"
            color="red"
            cls="mr-0 ml-0"
            :tooltip="{ top: true, bottom: false, attach: false }"
            :iconOptions="{ small: true }"
            @click="deleteEducation(props.item)"
          >
            {{ 'app.delete' | trans }}
          </icon-button>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { trans } from '../../../app';
import axios from 'axios';

export default {
  data: function () {
    return {
      headers: [
        {
          text: trans('app.created_at'),
          align: 'left',
          value: 'created_at',
          sortable: false,
        },
        {
          text: trans('app.education.tutor'),
          align: 'left',
          value: 'tutor',
          sortable: false,
        },
        {
          text: trans('app.education.video'),
          align: 'left',
          value: 'video',
          sortable: false,
        },
        {
          text: trans('app.education.name'),
          align: 'left',
          value: 'name',
          sortable: false,
        },
        {
          text: trans('app.education.short_description'),
          align: 'left',
          value: 'description',
          sortable: false,
        },
        {
          text: trans('app.education.description'),
          align: 'left',
          value: 'short_description',
          sortable: false,
        },
        {
          text: trans('app.pages.roles'),
          align: 'left',
          value: 'roles',
          sortable: false,
        },
        {
          text: trans('app.education.type'),
          align: 'left',
          value: 'roles',
          sortable: false,
        },
        {
          text: '',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['education']),
  },
  methods: {
    ...mapActions(['fetchEducation']),
    deleteEducation(education) {
      this.$confirmDanger(
          trans('app.confirm_removal'),
          trans('app.remove') + ' ' + trans('app.education.education_tab')
      ).then(async () => {
        await axios.delete(`/administrator/education/${education.id}`);
        await this.fetchEducation();
        this.$toast.success(trans('app.removed'));
      }).catch((error) => {
        this.sentryCaptureException(error);
      })
    },
    editEducation(education) {
      this.$emit('editEducation', education);
    },
  },
};
</script>

<style scoped></style>
